import React, { useEffect, useContext, useState } from "react"
import RightSideBar from "../section-right-side-bar"
import { JourneyContext } from "../../context/journeyContext"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { PageContext } from "../../context/pageContext"
import { applyComma, lineCapital } from "../../../shared/functions"
import { generateBI } from "../../../services/apiservice"
import { getValueFromLookup } from "../../services/helperFunctions"

// import RightSideBar from "../components/sections/section-right-side-bar"

export default function YourPremiumMoneyBack(props) {
  const [ journeyState, setJourneyState] = useContext(JourneyContext)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [ pageState, setPageState] = useContext(PageContext)
  
  const handlePrevious = () => {
    pageState.pageData.map((element, index) => {
      if (
        element.sectionId ===
        props.sections[props.currentSectionIndex - 1].sectionId // setting section context from page context
      ) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: element.sectionId,
            sectionData: element.sectionData,
          }
        })
      }
    })
    props.setCurrentSectionIndex(prev => prev -1)
  }

  const handleProceed = () => {
    props.setCurrentPageIndex(prev => prev +1)
    props.setCurrentSectionIndex(0)
  }

  useEffect(async () => {
    console.log("journeyState", journeyState);
    console.log(sectionState, "sectionState")
    if(!journeyState.moneyBackAdvantageBiKeys.premiumAmount){
      let payload = {
        journeyId: journeyState.journeyId,
      }
      const biApiData = await generateBI(payload)
      if (biApiData.data?.BIJson) {
        let biJson = JSON.parse(biApiData.data?.BIJson)
        let premiumAmount = Math.floor(biJson[0]?.["MODAL_PREM"])
        let totalMaturity4per = Math.floor(biJson[biJson.length -1]?.["TOTAL_MB_BS_2"])
        let totalMaturity8per = Math.floor(biJson[biJson.length -1]?.["TOTAL_MB_BS_1"])
        let gurantedPayout5th = Math.floor(biJson[4]?.["SB_G"])
        let gurantedPayout9th = Math.floor(biJson[8]?.["SB_G"])
        let gurantedPayout13th = Math.floor(biJson[12]?.["SB_G"])
        setJourneyState(prev => {
          return ({
            ...prev,
            "moneyBackAdvantageBiKeys": {
              "premiumAmount": premiumAmount,
              "totalMaturity4per": totalMaturity4per,
              "totalMaturity8per": totalMaturity8per,
              "gurantedPayout5th": gurantedPayout5th,
              "gurantedPayout9th": gurantedPayout9th,
              "gurantedPayout13th": gurantedPayout13th
            }
          })
        })
      }
    }
  }, []) 

  return (
    <>
      <style>
        {`
          .mg-ckyc-top.desktop-view-right-side {
            margin-top: 39px;
          }
          .money-payout-option-design {
              padding: 20px 20px;
            }
          
          .money-payout-option-design .title-bg1 {
            color: #fff;
            text-align: center;
            width: 100%;
            font-size: 20px;
          }

          .tot-price-money {
            padding: 10px;
            background-color: #fff;
            color: #0ab0ef;
            text-align: center;
            font-size: 20px;
          }
          
        
          @media (max-width: 767px) {
            .form-group span#plan_option-error {
              top: 49px;
            }
            .form-group span#policy_term-error {
              top: 51px;
            }
            .form-group span#payment_term-error {
              top: 50px;
            }
            .form-group span#payment_frequency-error {
              top: 51px;
            }
            .or-jeevan p{
              top: -14px;
            }
          }
        
          button.select2-selection__clear {
            display: none;
          }
        
          .form-group {
            position: relative;
          }
        
          .text-danger {
            color: #a94442;
            position: absolute;
            left: 0;
            bottom: -20px;
          }
        
          #swords {
            position: absolute;
            z-index: 2;
            right: 38px !important;
            top: 0px;
          }
        
          #sumAssured-error {
            position: absolute;
            bottom: -3px;
            z-index: 2;
          }
        
          button.select2-selection__clear {
            display: none;
          }
        
          .sumassuredselect select#nonfilterselect {
            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url("images/arrow-sm.png");
            background-repeat: no-repeat;
            background-position-x: 99%;
            background-position-y: 17px;
          }
        
          #words {
            position: absolute;
            right: 58px;
            top: 27px;
          }
        
          select::-ms-expand {
            display: none;
          }
        
          .sumassuredselect {
            position: relative;
            height: 45px;
            width: 100%;
          }
        
          .sumassuredselect input.form-control {
            position: absolute;
            z-index: 2;
            width: calc(100% - 35px);
            left: 3px;
            height: 42px;
            top: 0;
            box-shadow: none;
            border: 0;
            display: block !important;
            background: #ededed;
            border-right-color: transparent;
          }
        
          .sumassuredselect select#nonfilterselect {
            position: absolute;
            top: 0;
            width: 100%;
            left: 0;
            right: 0;
            background: #ededed;
            z-index: 1;
            text-align: center;
            border-left-color: transparent;
          }
          .or-jeevan {
            position: relative;
          }
          @media (min-width: 1024px) and (max-width: 1366px) {
            .top_space {
              margin-top: 11vh;
            }
          }
          .result-design {
            padding: 20px;
            margin-bottom: 30px;
            float: left;
            width: 100%;
          }
          .total-premium-jeevan-design{
            color: #fff;
            text-align: center;
            padding-bottom: 20px;
            border-bottom: 1px solid #fff;
          }
          .totalpr-jeevan {
            display: inline-block;
            font-size: 25px;
          }
          .price-jeevan {
            display: inline-block;
            font-size: 25px;
            text-decoration: underline;
            margin-left: 20px;

          }
          .total-premium-jeevan-design p {
            margin-top: 7px;
          }
          .total-meturity-jeevan {
            text-align: center;
            color: #fff;
            margin: 50px 0px;
            margin-top: 20px;
          }
          .total-meturity-jeevan h2 {
            background-color: #0ab0ef;
            padding: 4px;
            z-index: 2;
            position: relative;
            width: 250px;
            margin: auto;
            font-size: 25px;
          }
          .line-jeev {
            width: 480px;
            height: 2px;
            background-color: #fff;
            margin: auto;
            margin-top: -15px;
            z-index: 1;
            position: relative;
          }
          .wd-total-metrurity {
            width: 45.666667%;
          }
          .jeevan-neeves-premium {
            border: 1px solid #fff;
            padding: 17px 14px;
            float: left;
            width: 100%;
            margin-bottom: 5px;
          }
          .listing-total {
            float: left;
            width: 78%;
          }
          .price-jeevan-toal {
            list-style: none;
            color: #fff;
            padding: 0px;
            font-size: 92%;
            display: flex;
            justify-content: space-between;
          }
          .price-jeevan-toal li {
            // display: flex;
            // flex-direction:row;
          }
          .text-rt-jeevan {
            text-align: right;
            margin-right: 0px !important;
            float: right;
          }
          .total-mrp-jeevan {
            border-top: 1px solid #fff;
            padding-top: 10px;
            font-size: 20px;
            text-align: right;
            color: #fff;
            font-weight: bold;
          }
          .percnt-jeevan {
            float: right;
            background-color: #fff;
            padding: 35px 7px;
            color: #0ab0ef;
            font-size: 23px;
            height: 100px;
            font-weight: bold;
          }
          .or-jeevan {
            position: relative;
          }
          .or-jeevan {
            text-align: center;
            width: 1px;
            height: 150px;
            background-color: #fff;
            margin: auto;
          }
          .or-jeevan p {
            color: #fff;
            font-size: 20px;
            text-transform: uppercase;
            margin: 50px 10px;
            margin-left: -17px;
            background-color: #0ab0ef;
            position: absolute;
          }
          @media (min-width: 1400px){
            .box-container{
              padding:0px !important;
            }
          }

          @media (max-width: 1399px) and (min-width: 1260px){
            .listing-total{
              width:  80%;
            }
            .box-container{
              padding:0px !important;
            }

          }
          @media (max-width: 1259px) and (min-width: 992px){
            .percnt-jeevan{
              padding: 35px 7px;
              font-size: 1.2rem;
            }
            .price-jeevan-toal{
              font-size:89%;

            }
            .box-container{
              padding:00px !important;
            }
            .jeevan-neeves-premium1 {
              width:105%;
            }
            .wd-total-metrurity2{
              padding-left: 0px;
              margin-left: -8px;
            }
            .jeevan-neeves-premium2 {
              width:104%;
            }
            .listing-total{
              width:82%;
            }
            .jeevan-neeves-premium{
              padding: 17px 8px;
            }


          }
          @media (max-width: 991px) and (min-width: 768px){
            .total-premium-jeevan-design {
              padding-bottom: 7px;
            }
            .total-meturity-jeevan {
              margin-bottom: 30px;
            }
            .line-jeev {
              width: 94%;
            }
            .wd-total-metrurity {
              width: 100%;
            }
            .jeevan-neeves-premium {
                margin-bottom: 10px;
                padding: 10px;
            }
            .listing-total {
              margin-bottom: 10px;
              width:100%;
            }
            .price-jeevan-toal {
              margin-bottom: 10px;
            }
            .price-jeevan-toal li {
              font-size: 15px;
            }
            .total-mrp-jeevan {
              font-size: 20px;
              padding-top: 15px;
            } 
            .percnt-jeevan {
              width: 100%;
              text-align: center;
              height: 35px;
              padding: 0px;
              display: flex;
              align-items: center;
              justify-content: space-around;
            }
            .or-jeevan {
              width: 100%;
              height: 1px;
              margin: 30px 0px;
            }
            .or-jeevan p {
              width: 45px;
              left: 0px;
              right: 0px;
              margin: auto;
              top: -13px;
            }
          }
          
          @media (max-width: 767px){
            .fund-value-container{
              padding:25px !important;
            }
            .result-design {
                padding: 12px;
                padding-bottom: 30px;
            }
            .pl-pr {
              padding: 0px;
            }
            .wd-total-metrurity {
              width: 100%;
            }
            .total-premium-jeevan-design {
              padding-bottom: 7px;
            }
            .total-meturity-jeevan {
              margin-bottom: 30px;
            }
            .total-meturity-jeevan h2 {
              font-size: 20px;
              width: 200px;
              display: inline-block;
              margin-top: 15px;
            }
            .line-jeev {
              width: 94%;
            }
            .jeevan-neeves-premium {
              
              padding: 10px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
            .price-jeevan-toal li {
              font-size: 12px;
            }
            .price-jeevan-toal li {
              font-size: 12px;
            }
            .total-mrp-jeevan {
              font-size: 20px;
              padding-top: 5px;
            }
            .percnt-jeevan {
              width: 100%;
              text-align: center;
              height: 40px;
              padding: 0px;
            }
            .or-jeevan {
              width: 100%;
              height: 1px;
              margin: 30px 0px;
            }
            .or-jeevan p {
              top: -14px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
            .or-jeevan p {
              width: 45px;
              left: 0px;
              right: 0px;
              margin: auto;
              top: -13px;
          }
          
          }
          
          @media (min-width: 768px) and (max-width: 991px){
              .pl-pr {
                padding: 0px;
              }
              .total-meturity-jeevan h2 {
                  font-size: 20px;
                  width: 200px;
                  display: inline-block;
                  margin-top: 15px;
              }
          
            }
            @media (max-width: 991px){
              .paddingTop30{
                padding-top:25px;
              }
              .money-payout-option-design{
                margin-left:-5px !important;
              }
              .paddingtop{
                padding-top:20px !important;
              }
            }

          `}
      </style>
      <div className="container">
        <div className="row">
          <div className="col-lg-9 pl-pr brd-right mt-20 fund-value-container">
            <div className="row">
              <div className="col-lg-12 pl-pr">
                <div className="iselect-box-design mg-bottom-10 new-iselect-box">
                  <div className="heading-design">
                    <div className="iselect-padding left-side-head">
                      <h1 className="iselect-heading">
                        {" "}
                        Your Premium Quotation
                      </h1>
                    </div>
                    <div class="app-quatation mt hidden-desktop-screen">
                      <div class="application-design-number">Application Number: {journeyState.applicationNo}</div>
                    </div>
                  </div>
                  <div class="iselect-padding">
                    <div class="result-design">
                      <div class="row">
                        <div class="col-lg-12 pl-pr">
                          <div class="total-premium-jeevan-design">
                            <div class="totalpr-jeevan">Premium:</div>
                            <div
                              class="price-jeevan"
                              style={{
                                textDecoration: "none",
                                "margin-left": "2px",
                              }}
                            >
                              <span class="fa fa-rupee"></span>
                              <strong> {applyComma(journeyState.moneyBackAdvantageBiKeys.premiumAmount) } </strong>
                              <small style={{ fontSize: "16px" }}>
                                {" "}
                                {getValueFromLookup("premiumFrequency", journeyState.paymentFrequency).toLowerCase()}{" "}
                              </small>
                            </div>
                            <p style={{ fontStyle: "italic" }}>
                              The premium shown above is exclusive of taxes.
                            </p>
                          </div>

                          <div style={{ borderBottom: "1px solid #fff" }}>
                            <div class="row inside-row">
                              <div
                                class="col-lg-12 col-12 pl-pr paddingtop"
                                style={{
                                  display: "grid",
                                  placeItems: "center",
                                  paddingTop: "30px",
                                }}
                              >
                                <h4 class="sas">
                                  Guaranteed* Payouts in Money Back
                                </h4>{" "}
                              </div>
                            </div>
                            <div
                              className="money-payout-option-design row"
                              style={{ marginLeft: "20px" }}
                            >
                              <div className="col-lg-4 col-12 pl pr-30">
                                <label class="title-bg1"> 5th Year </label>
                                <div
                                  className="tot-price-money"
                                  style={{ background: "#fff" }}
                                >
                                  {applyComma(journeyState.moneyBackAdvantageBiKeys.gurantedPayout5th) }
                                </div>
                              </div>
                              <div className="col-lg-4 col-12 pl pr-30 paddingTop30">
                                <label class="title-bg1"> 9th Year </label>
                                <div
                                  className="tot-price-money"
                                  style={{ background: "#fff" }}
                                >
                                  {applyComma(journeyState.moneyBackAdvantageBiKeys.gurantedPayout9th) }
                                </div>
                              </div>
                              <div className="col-lg-4 col-12 pl pr-30  paddingTop30">
                                <label class="title-bg1"> 13th Year </label>
                                <div
                                  className="tot-price-money"
                                  style={{ background: "#fff" }}
                                >
                                  {applyComma(journeyState.moneyBackAdvantageBiKeys.gurantedPayout13th) }
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-12">
                              <div class="total-meturity-jeevan">
                                <h2>
                                  Total Maturity Value <sup>#</sup>
                                </h2>
                                <div class="line-jeev"></div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row box-container"
                            style={{ padding: "25px" }}
                          >
                            <div class="col-lg-5 col-12 pl pl-pr wd-total-metrurity ">
                              <div class="jeevan-neeves-premium jeevan-neeves-premium1">
                                <div class="listing-total">
                                  <ul class="price-jeevan-toal">
                                    <li>Total Maturity Benifit @8%</li>
                                    <li class="text-rt-jeevan">
                                      <span class="fa fa-rupee"></span>{" "}
                                      {applyComma(journeyState.moneyBackAdvantageBiKeys.totalMaturity8per) }
                                    </li>
                                  </ul>

                                  <div class="total-mrp-jeevan">
                                    {" "}
                                    <span class="fa fa-rupee"></span> {applyComma(journeyState.moneyBackAdvantageBiKeys.totalMaturity8per) }
                                  </div>
                                </div>
                                <div class="percnt-jeevan">8%</div>
                              </div>
                            </div>
                            <div class="col-lg-1 col-12 pl-pr">
                              <div class="or-jeevan">
                                <p>Or</p>
                              </div>
                            </div>
                            <div class="col-lg-5 col-12 pr pl-pr wd-total-metrurity  wd-total-metrurity2">
                              <div class="jeevan-neeves-premium jeevan-neeves-premium2">
                                <div class="listing-total">
                                  <ul class="price-jeevan-toal">
                                    <li>Total Maturity Benifit @4%</li>
                                    <li class="text-rt-jeevan">
                                      <span class="fa fa-rupee"></span>{" "}
                                     {applyComma(journeyState.moneyBackAdvantageBiKeys.totalMaturity4per) }
                                    </li>
                                  </ul>

                                  <div class="total-mrp-jeevan">
                                    {" "}
                                    <span class="fa fa-rupee"></span>{applyComma(journeyState.moneyBackAdvantageBiKeys.totalMaturity4per) }
                                  </div>
                                </div>
                                <div class="percnt-jeevan">4%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <div class="hidden-desktop-screen">
                    <div class="iselect-mg-bottom mt-30">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="but-center text-center">
                            <div class="submit-btn cen" aria-hidden="true" onClick={handlePrevious}>
                              {" "}
                              <a>Previous</a>{" "}
                            </div>
                            <input
                              class="previous-btn cen inline-btn-wd"
                              style={{
                                color: "white",
                                border: "none",
                                padding: "14px 40px",
                              }}
                              type="button"
                              aria-hidden="true"
                              onClick={handleProceed}
                              value="View BI to Proceed"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RightSideBar
            sections={props.sections}
            currentSectionIndex={props.currentSectionIndex}
            setCurrentSectionIndex={props.setCurrentSectionIndex}     
            showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
            setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}  
            channelForColorChange = {journeyState.channel}      
          />
        </div>
        <div class="clearfix"></div>
        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design" style={{paddingBottom:"10px"}}>
              <h5><b>Disclousers;</b></h5>
              <ul style={{listStyle:"none"}}>
                <li>
                  - Canara HSBC Life Insurance Money Back Advantage Plan is an
                  Individual Non-Linked Par Life Insurance Savings cum
                  Protection Plan.
                </li>
                <li>
                  - **Maturity Benefit payable under this plan is Guranted Sum
                  Assured on Maturity plus Accured Annual Bonus and Final Bonus,
                  if any.
                </li>
                <li>
                  - * There is no guarantee on the amount of bonuses and these
                  will be declared at the sole discretion of the company. Hence
                  the bonus in this plan may vary from time to time.
                </li>
                <li>
                  - The policy will be eligible for bonuses from the profit
                  emerging out of the with-profit fund managed by the company by
                  way of annual bonuses and final bonus, if any. The company
                  will declare the annual bonus at the end of each financial
                  year and once declared, the annual bonus will get accured to
                  the policy and is guaranteed to be payable.
                </li>
                <li>
                  - Tax benefits under this plan will be as per the prevailing
                  income tax laws and are subject to amendment from time to
                  time. For tax related queries, contact your independent tax
                  advisor.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design" style={{marginTop:"0px",paddingBottom:"0px",paddingTop:"0px"}}>
              <h5><b>Disclaimers:</b></h5>
              <ul style={{listStyle:"none"}}>
                <li>
                  - #The assumed rates of return (4% p.a. or 8% p.a.) shown
                  above are not guaranteed and they are not the upper or lower
                  limits of what you might get back as the value of your policy
                  depends on a number of factors including future investment
                  performance. The fund values shown above are after deduction
                  of all charges (including goods and service tax & Applicable
                  cess (es)/levy, if any @ 18%).
                </li>
                <li>
                  - Issuance of the policy and acceptance of the risk is
                  complete at the discretion of the Canara HSBC Life Insurance
                  Company Limited ("Company").
                </li>
                <li>
                  - The actual premium or the sum assured amount may change upon
                  assessment of the risk of the life insured by the Company's
                  underwriters. Any such change will be informed to you for your
                  consent.
                </li>
                <li>
                  - The above premium is for the healthy individual. Your
                  application will be assessed as per board approved
                  underwriting guidlines of the company. Basis underwriting, it
                  may result in an extra premium to be paid, which shall be
                  borne by you.
                </li>
                <li>
                  - For more details on risk factors, terms and conditions
                  please read the sales brochure carefully before concluding a
                  sale.
                </li>
                <li>
                  - The above mentioned quote is valid till next birthday or 30
                  days from the quote generation date whichever is earlier.
                </li>
                <li>
                  - For any further clarifications, please feel free to contact
                  us at 1800-103-0003/1800-180-0003/1800-891-0003 or email us at
                  customerservice@canarahsbclife.in or visit our website
                  www.canarahsbclife.com.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile view Buttons */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
          <div className="row">
            <div className="col-lg-12">
              <div className="but-center text-center">
                <div className="submit-btn cen" style={{ paddingLeft: "5px" }} aria-hidden="true" onClick={handlePrevious}>
                  {" "}
                  <a>Previous </a>{" "}
                </div>
                <input
                  className="previous-btn cen bi-btv"
                  style={{
                    color: "white",
                    padding: "14px 0px",
                    border: "none",
                    marginLeft: "10px",
                    width: "160px",
                  }}
                  type="button"
                  form="aDetail"
                  align="right"
                  onClick={handleProceed}
                  aria-hidden="true"
                  value="View BI to Proceed"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
